import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["documentTypeCategories"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import * as xlsx from "xlsx";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import { request } from "@/js/http/http_request";
import { scrollTo } from "@/js/animation";
import { hasRole } from "@/js/http/auth.js";
import { platformDocumentTypes, emptyCellContent, pricePostingStatusList } from "@/js/lists.ts";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import * as reporting from "@/js/reporting/reporting.js";
import { formatPrice } from "@/js/currency/currencies.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import WineryDashboardFormModal from "@/components/public-dashboards/wineries/WineryDashboardFormModal.vue";
import PaymentSearchDialog from "@/components/payment/PaymentSearchDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "IndicatorsList",
  components: {
    DatePicker: DatePicker,
    Confirm: Confirm,
    WineryDashboardFormModal: WineryDashboardFormModal,
    PaymentSearchDialog: PaymentSearchDialog,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data(_this) {
    return {
      loaded: false,
      tab: null,
      hasAccessToSuperAdminData: false,
      canManagePricePosting: false,
      canManageWineryDashboards: false,
      formSearch: {
        dateStart: null,
        dateEnd: null
      },
      isGeneratingDashboard: false,
      turnover: 0,
      nb_orders_made: 0,
      nb_btl_orders: 0,
      kpiSearch: {
        type: 1,
        wineriyIds: [],
        wineIds: []
      },
      isExportingKpi: false,
      kpiExportTypes: {
        ORDERS_REPORT: {
          text: "Orders report (xlsx)",
          value: 1,
          apiUrl: "main-report",
          fileName: "PLATFORM_KPI_ORDERS_REPORT_INVOICE_DATE.xlsx",
          isLimitedToSuperAdminRole: false
        },
        CREDIT_NOTES_REPORT: {
          text: "Credit notes report (xlsx)",
          value: 3,
          apiUrl: "creditnotes-report",
          fileName: "PLATFORM_KPI_CREDIT_NOTES_REPORT.xlsx",
          isLimitedToSuperAdminRole: false
        },
        SALES: {
          text: "Sales KPI (xlsx)",
          value: 4,
          apiUrl: "sales",
          fileName: "PLATFORM_KPI_SALES.xlsx",
          isLimitedToSuperAdminRole: false
        },
        STOCKS: {
          text: "Stocks KPI, at export moment (xlsx)",
          value: 5,
          apiUrl: "stocks",
          fileName: "PLATFORM_KPI_STOCKS.xlsx",
          isLimitedToSuperAdminRole: true
        },
        USERS: {
          text: "Users KPI (xlsx)",
          value: 6,
          apiUrl: "users",
          fileName: "PLATFORM_KPI_USERS.xlsx",
          isLimitedToSuperAdminRole: false
        },
        VARIOUS: {
          text: "Producers data, at export moment (xlsx)",
          value: 7,
          apiUrl: "producers",
          fileName: "PLATFORM_KPI_PRODUCERS.xlsx",
          isLimitedToSuperAdminRole: true
        }
      },
      producers: [],
      wines: [],
      dataSearch: {
        type: 1,
        consultantIds: []
      },
      isExportingData: false,
      dataExportTypes: {
        CONSULTANT_COMMISSIONS: {
          text: "Consultant's & corporate's commissions (xlsx)",
          value: 1,
          apiUrl: "consultant-commission",
          fileName: "PLATFORM_DATA_CONSULTANT_COMMISSION.xlsx",
          isLimitedToSuperAdminRole: false
        },
        SALESMAN_COMMISSIONS: {
          text: "Salesperson's commissions (xlsx)",
          value: 2,
          apiUrl: "salesman-commission",
          fileName: "PLATFORM_DATA_SALESPERSON_COMMISSION.xlsx",
          isLimitedToSuperAdminRole: false
        },
        INVOICE_SUMMARY: {
          text: "Invoices for Audit (xlsx)",
          value: 3,
          apiUrl: "invoices-summary-for-audit",
          fileName: "PLATFORM_DATA_INVOICE_SUMMARY_FOR_AUDIT.xlsx",
          isLimitedToSuperAdminRole: true
        },
        BANK_PAYMENTS: {
          text: "Bank payments report (xlsx)",
          value: 4,
          apiUrl: "bank-payments",
          fileName: "BANK_PAYMENTS_REPORT.xlsx",
          isLimitedToSuperAdminRole: true
        },
        VAT_DECLARATION: {
          text: "VAT declaration (xlsx)",
          value: 5,
          apiUrl: "vat-declaration",
          isLimitedToSuperAdminRole: true
        },
        INVOICES: {
          text: "Invoices (pdf)",
          value: 6,
          apiUrl: "invoices",
          fileName: "PLATFORM_INVOICES.zip",
          isLimitedToSuperAdminRole: false
        },
        CREDIT_NOTES: {
          text: "Credit notes (pdf)",
          value: 7,
          apiUrl: "creditnotes",
          fileName: "PLATFORM_CREDITNOTES.zip",
          isLimitedToSuperAdminRole: false
        }
      },
      consultants: [],
      showPaymentSearchDialog: false,
      documents: {
        documentTypeCategoriesList: [{
          value: "ORDERS",
          label: "Orders platform & attached files",
          documentTypeIds: [platformDocumentTypes.ORDERS_AUTO.id, platformDocumentTypes.ORDERS_ATTACHED.id]
        }, {
          value: "ORDERS DISPATCH",
          label: "Orders dispatch platform & attached files",
          documentTypeIds: [platformDocumentTypes.INBOUND_DELIVERIES_AUTO.id, platformDocumentTypes.INBOUND_DELIVERIES_ATTACHED.id, platformDocumentTypes.ORDERS_CONFIRMATION_AUTO.id, platformDocumentTypes.ORDERS_CONFIRMATION_ATTACHED.id]
        }, {
          value: "PURCHASE_ORDERS",
          label: "Purchase orders platform & attached files",
          documentTypeIds: [platformDocumentTypes.PURCHASE_ORDERS_AUTO.id, platformDocumentTypes.PURCHASE_ORDERS_ATTACHED.id]
        }, {
          value: "CREDIT_NOTES",
          label: "Credit notes platform & attached files",
          documentTypeIds: [platformDocumentTypes.CREDIT_NOTES_AUTO.id, platformDocumentTypes.CREDIT_NOTES_ATTACHED.id]
        }, {
          value: "WINES",
          label: "Products attached files",
          documentTypeIds: [platformDocumentTypes.WINES_ATTACHED.id]
        }, {
          value: "WINERIES",
          label: "Producers attached files",
          documentTypeIds: [platformDocumentTypes.WINERIES_ATTACHED.id]
        }],
        formSearch: {
          labelSearch: "",
          documentTypeCategories: [],
          insertDateStart: null,
          insertDateEnd: null
        },
        searchLabelLastUsed: "",
        searchCategoriesLastUsed: [],
        results: {
          headers: [{
            text: "Type",
            value: "type",
            align: "left",
            width: "130px",
            cellClass: "text-nowrap"
          }, {
            text: "Filename",
            value: "filename",
            align: "left",
            width: "200px"
          }, {
            text: "Tag",
            value: "tag",
            align: "center",
            cellClass: "text-nowrap"
          }, {
            text: "Related",
            value: "relativeParentId",
            align: "center"
          }, {
            text: "Date",
            value: "creationDate",
            align: "center"
          }, {
            text: "Actions",
            value: "absoluteAccessUri",
            align: "right",
            cellClass: "text-nowrap"
          }],
          items: [],
          totalCount: null
        },
        cancellationToken: null,
        isDataLoading: false,
        isCopyingToClipboard: false
      },
      pricePosting: {
        minDate: null,
        form: {
          applicationDate: null
        },
        results: {
          headers: [{
            text: "ApplicationDate",
            value: "applicationDate",
            align: "center"
          }, {
            text: "ExpirationDate",
            value: "expirationDate",
            align: "center"
          }, {
            text: "Status",
            value: "status",
            align: "center"
          }, {
            text: "NYSLA File",
            value: "urlBatchFile",
            align: "center"
          }, {
            text: "HAL File",
            value: "urlHalPriceFile",
            align: "center"
          }, {
            text: "Products",
            value: "numberOfWines",
            align: "center"
          }, {
            text: "Modifications from generation",
            value: "numberOfManualModifications",
            align: "center"
          }, {
            text: "Creation",
            value: "creation",
            align: "left"
          }, {
            text: "Actions",
            value: "actions",
            align: "right",
            cellClass: "text-nowrap"
          }],
          items: [],
          totalCount: null
        },
        isDataLoading: false,
        cancellationTokenGet: null,
        statusList: _objectSpread({}, pricePostingStatusList),
        isDataCreating: false,
        lastErrorCreating: null,
        cancellationTokenPost: null,
        isDataDuplicating: false,
        cancellationTokenDuplicate: null,
        regeneratingNysla: {
          isPending: false,
          cancellationToken: null
        },
        regeneratingHal: {
          isPending: false,
          cancellationToken: null
        },
        downloadingModification: {
          isPending: false,
          cancellationToken: null,
          results: []
        }
      },
      platformDocumentTypes: platformDocumentTypes,
      wineryDashboards: {
        formSearch: {
          wineryId: null,
          excludeInactive: false
        },
        lastSearch: {
          wineryId: null,
          excludeInactive: false
        },
        results: {
          headers: [{
            text: "Title",
            value: "title",
            align: "left"
          }, {
            text: "Producer",
            value: "wineries",
            align: "left"
          }, {
            text: "Turnover",
            value: "isShowTurnover",
            align: "center"
          }, {
            text: "Active",
            value: "isActive",
            align: "center"
          }, {
            text: "Creation",
            value: "creationDate",
            align: "center"
          }, {
            text: "",
            value: "actions",
            align: "right",
            cellClass: "text-nowrap"
          }],
          items: [],
          totalCount: null
        },
        cancellationToken: null,
        isDataLoading: false,
        isCopyingToClipboard: false,
        editedId: null
      },
      emptyCellContent: emptyCellContent,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    showIndicators: function showIndicators() {
      return this.loaded && this.nb_orders_made > 0;
    },
    kpiExportTypesAllowed: function kpiExportTypesAllowed() {
      if (this.hasAccessToSuperAdminData) {
        return Object.values(this.kpiExportTypes);
      } else {
        return Object.values(this.kpiExportTypes).filter(function (x) {
          return !x.isLimitedToSuperAdminRole;
        });
      }
    },
    dataExportTypesAllowed: function dataExportTypesAllowed() {
      if (this.hasAccessToSuperAdminData) {
        return Object.values(this.dataExportTypes);
      } else {
        return Object.values(this.dataExportTypes).filter(function (x) {
          return !x.isLimitedToSuperAdminRole;
        });
      }
    },
    pricePostingIsAnyActionInProgress: function pricePostingIsAnyActionInProgress() {
      return this.pricePosting.isDataCreating || this.pricePosting.isDataDuplicating || this.pricePosting.regeneratingHal.isPending || this.pricePosting.regeneratingNysla.isPending;
    }
  },
  created: function created() {
    this.hasAccessToSuperAdminData = hasRole(process.env.VUE_APP_ROLES_MANAGE_GET_SUPER_ADMIN_INDICATORS);
    this.canManagePricePosting = hasRole(process.env.VUE_APP_ROLES_MANAGE_PRICE_POSTING);
    this.canManageWineryDashboards = hasRole(process.env.VUE_APP_ROLES_MANAGE_WINERY_DASHBOARDS);
    this.formSearch.dateEnd = moment().startOf("month").format("YYYY-MM-DD");
    this.formSearch.dateStart = moment().startOf("month").subtract(1, "month").format("YYYY-MM-DD");
    this.fetchConsultants();
    this.fetchProducers();
    //this.fetchWines()

    this.documents.formSearch.insertDateEnd = moment().startOf("month").add(1, "month").format("YYYY-MM-DD");
    this.documents.formSearch.insertDateStart = moment().startOf("month").subtract(1, "month").format("YYYY-MM-DD");
    this.pricePosting.minDate = moment().date() <= 4 ? moment().add(0, "month").startOf("month").toDate().formatForDatePickerMonths() : moment().add(1, "month").startOf("month").toDate().formatForDatePickerMonths();
    this.pricePosting.form.applicationDate = moment().date() <= 4 ? moment().add(1, "month").startOf("month").toDate().formatForDatePickerMonths() : moment().add(2, "month").startOf("month").toDate().formatForDatePickerMonths();
    this.fetchPricePostings();
    this.wineryDashboardsSearch();
  },
  methods: {
    formatPrice: formatPrice,
    generateBankPaymentsFileName: function generateBankPaymentsFileName() {
      var _this$formSearch, _this$formSearch2;
      return "BANK_PAYMENTS_REPORT_".concat((_this$formSearch = this.formSearch) === null || _this$formSearch === void 0 ? void 0 : _this$formSearch.dateStart, "_to_").concat((_this$formSearch2 = this.formSearch) === null || _this$formSearch2 === void 0 ? void 0 : _this$formSearch2.dateEnd, ".xlsx");
    },
    generateVatFileName: function generateVatFileName() {
      var _this$formSearch3, _this$formSearch4;
      return "VAT_DECLARATION_".concat((_this$formSearch3 = this.formSearch) === null || _this$formSearch3 === void 0 ? void 0 : _this$formSearch3.dateStart, "_to_").concat((_this$formSearch4 = this.formSearch) === null || _this$formSearch4 === void 0 ? void 0 : _this$formSearch4.dateEnd, ".xlsx");
    },
    fetchConsultants: function fetchConsultants() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;
              data = {
                isConsultantOrHolding: true
              };
              _context.next = 4;
              return request("/v1/users", "post", data, true, "api").catch(function () {
                _this.$toasted.show("Unable to load consultant list", {
                  type: "warning"
                });
                throw e;
              });
            case 4:
              response = _context.sent;
              _this2.consultants = _toConsumableArray(response.data.users);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchProducers: function fetchProducers() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _context2.next = 3;
              return request("/v1/producers/all", "post", {}, true, "api").catch(function () {
                _this.$toasted.show("Unable to load the list of producers", {
                  type: "warning"
                });
                throw e;
              });
            case 3:
              response = _context2.sent;
              _this3.producers = _toConsumableArray(response.data.value.items);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchWines: function fetchWines() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this4;
              data = {
                paging: null,
                calculate_prices: false,
                only_display_names: true,
                bypassStockSeek: true,
                byPassPagingLimitation: true
              };
              _context3.next = 4;
              return request("/v1/wines", "post", data, true, "api").catch(function () {
                _this.$toasted.show("Unable to load the list of wines", {
                  type: "warning"
                });
                throw e;
              });
            case 4:
              response = _context3.sent;
              _this4.wines = _toConsumableArray(response.data.wines.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                });
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    searchIndicators: function searchIndicators() {
      this.isGeneratingDashboard = true;
      this.loaded = false;
      if (this.nb_orders_made > 0) {
        reporting.disposeCharts();
        this.nb_orders_made = 0;
      }
      var _this = this;
      request("/v1/indicators", "post", _this.formSearch, true, "api").then(function (response) {
        _this.nb_orders_made = response.data.nb_orders_made;
        _this.turnover = response.data.turnover;
        _this.nb_btl_orders = response.data.nb_btl_orders;
        if (_this.nb_orders_made > 0) {
          reporting.showPieChartIndicators(response.data.wine_types, _this.$refs.wineType);
          reporting.showPieChartIndicators(response.data.destinations, _this.$refs.destination);
          if (_this.$whitelabel.isMultipleWineries) {
            reporting.showPieChartIndicators(response.data.producers, _this.$refs.producers);
            reporting.showPieChartIndicators(response.data.turnover_by_wineries, _this.$refs.turnoverWineries);
          }
          reporting.showLineChartUserTypes(response.data.user_types, _this.$refs.userTypes);
          reporting.showBarChartDestinationUserTypes(response.data.destinations_user_types, _this.$refs.destinationByUserTypes);
          reporting.showBarChartReferences(response.data.references, _this.$refs.references);
        }
        _this.loaded = true;
        _this.isGeneratingDashboard = false;
        if (_this.nb_orders_made > 0) {
          _this.$nextTick(function () {
            scrollTo(".indicators-global-container");
          });
        }
      }).catch(function (_) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
        _this.isGeneratingDashboard = false;
      });
    },
    exportKpi: function exportKpi() {
      var _this5 = this;
      var kpiConstants = Object.values(this.kpiExportTypes).find(function (x) {
        return x.value == _this5.kpiSearch.type;
      });
      var data = this.formSearch;
      var _this = this;
      _this.isExportingKpi = true;
      request("/v1/kpi/" + kpiConstants.apiUrl + "/", "post", data, true, "api", "blob").then(function (response) {
        _this.isExportingKpi = false;
        fileDownload(response.data, kpiConstants.fileName, "application/xlsx");
      }).catch(function (_) {
        _this.isExportingKpi = false;
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    },
    exportData: function exportData() {
      var _this6 = this;
      var dataConstants = Object.values(this.dataExportTypes).find(function (x) {
        return x.value == _this6.dataSearch.type;
      });
      var data = this.formSearch;
      if (dataConstants.value === this.dataExportTypes.CONSULTANT_COMMISSIONS.value) {
        data.consultantIds = _toConsumableArray(this.dataSearch.consultantIds);
      }
      var _this = this;
      _this.isExportingData = true;
      request("/v1/data/" + dataConstants.apiUrl + "/", "post", data, true, "api", "blob").then(function (response) {
        _this.isExportingData = false;
        if (dataConstants.apiUrl === "invoices" || dataConstants.apiUrl === "creditnotes") {
          fileDownload(response.data, dataConstants.fileName, "application/zip");
        } else {
          var filename = dataConstants.fileName;
          if (dataConstants.apiUrl === _this.dataExportTypes.BANK_PAYMENTS.apiUrl) filename = _this.generateBankPaymentsFileName();else if (dataConstants.apiUrl === _this.dataExportTypes.VAT_DECLARATION.apiUrl) filename = _this.generateVatFileName();
          fileDownload(response.data, filename, "application/xlsx");
        }
      }).catch(function (_) {
        _this.isExportingData = false;
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    },
    documentsSearch: function documentsSearch() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$documents$cance;
        var _this7$documents$form, documentTypeCategories, data, _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.documents.isDataLoading = true;
              _this7.documents.results.items = [];
              _this7.documents.results.totalCount = 0;
              _this7.documents.searchLabelLastUsed = _this7.documents.formSearch.labelSearch;
              _this7.documents.searchCategoriesLastUsed = _this7.documents.formSearch.documentTypeCategories;
              _this7$documents$form = _this7.documents.formSearch, documentTypeCategories = _this7$documents$form.documentTypeCategories, data = _objectWithoutProperties(_this7$documents$form, _excluded);
              data.documentTypes = _this7.documents.formSearch.documentTypeCategories.reduce(function (acc, current) {
                acc = [].concat(_toConsumableArray(acc), _toConsumableArray(_this7.documents.documentTypeCategoriesList.find(function (x) {
                  return x.value === current;
                }).documentTypeIds));
                return acc;
              }, []);
              _this = _this7;
              (_this$documents$cance = _this.documents.cancellationToken) === null || _this$documents$cance === void 0 || _this$documents$cance.cancel();
              _this.documents.cancellationToken = axios.CancelToken.source();
              _context4.next = 12;
              return request("/v1/ged/all", "post", data, true, "api", null, _this.documents.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.documents.isDataLoading = false;
                  _this.$toasted.show("An error occured. Please contact an administrator.", {
                    type: "error"
                  });
                }
                throw e;
              });
            case 12:
              response = _context4.sent;
              _this7.documents.results.items = response.data.items.reduce(function (acc, items) {
                if (items.items) acc = [].concat(_toConsumableArray(acc), _toConsumableArray(items.items));
                return acc;
              }, []);
              _this7.documents.results.totalCount = response.data.totalNumber;
              _this7.documents.isDataLoading = false;
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    documentsRowClick: function documentsRowClick(item) {
      this.documentDownload(item.absoluteAccessUri, item.filename);
    },
    documentDownload: function documentDownload(url, filename) {
      var _this8 = this;
      fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        var blobURL = URL.createObjectURL(blob);
        var downloadLink = document.createElement("a");
        downloadLink.href = blobURL;
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        URL.revokeObjectURL(blobURL);
      }).catch(function () {
        _this8.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    },
    documentCopyLink: function documentCopyLink(item) {
      var _this9 = this;
      this.documents.isCopyingToClipboard = true;
      setTimeout(function () {
        _this9.documents.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(item.absoluteAccessUri);
    },
    documentGoToRelated: function documentGoToRelated(item) {
      if ([platformDocumentTypes.ORDERS_AUTO.id, platformDocumentTypes.ORDERS_ATTACHED.id, platformDocumentTypes.ORDERS_CONFIRMATION_AUTO.id, platformDocumentTypes.ORDERS_CONFIRMATION_ATTACHED.id].includes(item.type)) {
        return {
          name: "adminOrderSummary",
          params: {
            id: item.relativeParentId
          }
        };
      } else if ([platformDocumentTypes.INBOUND_DELIVERIES_AUTO.id, platformDocumentTypes.INBOUND_DELIVERIES_ATTACHED.id].includes(item.type)) {
        return {
          name: "adminInboundDeliveryDetails",
          params: {
            id: item.relativeParentId
          }
        };
      } else if ([platformDocumentTypes.PURCHASE_ORDERS_AUTO.id, platformDocumentTypes.PURCHASE_ORDERS_ATTACHED.id].includes(item.type)) {
        return {
          name: "adminEditPurchaseOrder",
          params: {
            id: item.relativeParentId
          }
        };
      } else if ([platformDocumentTypes.CREDIT_NOTES_AUTO.id, platformDocumentTypes.CREDIT_NOTES_ATTACHED.id].includes(item.type)) {
        return {
          name: "adminEditCreditNote",
          params: {
            id: item.relativeParentId
          }
        };
      } else if ([platformDocumentTypes.WINES_ATTACHED.id].includes(item.type)) {
        return {
          name: "adminWineDetails",
          params: {
            id: item.relativeParentId
          }
        };
      } else if ([platformDocumentTypes.WINERIES_ATTACHED.id].includes(item.type)) {
        return {
          name: "adminProducerDetails",
          params: {
            id: item.relativeParentId
          }
        };
      }
    },
    pricePostingTargetMonthHasAlreadySomeModifications: function pricePostingTargetMonthHasAlreadySomeModifications() {
      var _this$pricePosting$re,
        _this10 = this;
      var targetMonth = moment(this.pricePosting.form.applicationDate, "YYYY-MM");
      var matchItem = (_this$pricePosting$re = this.pricePosting.results.items) === null || _this$pricePosting$re === void 0 ? void 0 : _this$pricePosting$re.find(function (item) {
        return moment(item.applicationDate).isSame(targetMonth, "month") && item.status !== _this10.pricePosting.statusList.CANCELLED.id;
      });
      return (matchItem === null || matchItem === void 0 ? void 0 : matchItem.numberOfManualModifications) > 0;
    },
    pricePostingCreateConfirm: function pricePostingCreateConfirm() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!_this11.pricePostingTargetMonthHasAlreadySomeModifications()) {
                _context5.next = 7;
                break;
              }
              _context5.next = 3;
              return _this11.$refs.confirm.open("WARNING", "There are some manual modifications on the price list of this month requested. Have you already download the manual modificaitons list, to reproduce them ? Do you agree that these modificaitons will be lost ?", {
                width: 380,
                color: "red"
              });
            case 3:
              ok = _context5.sent;
              if (ok) _this11.pricePostingCreate();
              _context5.next = 8;
              break;
            case 7:
              _this11.pricePostingCreate();
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    pricePostingCreate: function pricePostingCreate() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this$pricePosting$ca;
        var applicationDate, data, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this12.pricePosting.isDataCreating = true;
              _this12.pricePosting.lastErrorCreating = null;
              applicationDate = moment(_this12.pricePosting.form.applicationDate);
              data = {
                applicationYear: applicationDate.year(),
                applicationMonth: applicationDate.month() + 1
              };
              _this = _this12;
              (_this$pricePosting$ca = _this.pricePosting.cancellationTokenPost) === null || _this$pricePosting$ca === void 0 || _this$pricePosting$ca.cancel();
              _this.pricePosting.cancellationTokenPost = axios.CancelToken.source();
              _context6.next = 9;
              return request("/v1/price-posting/", "post", data, true, "api", null, _this.pricePosting.cancellationTokenPost).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.pricePosting.isDataCreating = false;
                  _this.pricePosting.lastErrorCreating = e.response.data.value;
                  var errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to create price posting", true);
                  handleErrorData(_this, errorData);
                  _this12.fetchPricePostings();
                }
                throw e;
              });
            case 9:
              _this12.pricePosting.lastErrorCreating = null;
              _this12.pricePosting.isDataCreating = false;
              _this12.fetchPricePostings();
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    pricePostingDuplicateFromPreviousMonthConfirm: function pricePostingDuplicateFromPreviousMonthConfirm() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!_this13.pricePostingTargetMonthHasAlreadySomeModifications()) {
                _context7.next = 7;
                break;
              }
              _context7.next = 3;
              return _this13.$refs.confirm.open("WARNING", "There are some manual modifications on the price list of this month requested. Have you already download the manual modificaitons list, to reproduce them ? Do you agree that these modificaitons will be lost ?", {
                width: 380,
                color: "red"
              });
            case 3:
              ok = _context7.sent;
              if (ok) _this13.pricePostingDuplicateFromPreviousMonth();
              _context7.next = 8;
              break;
            case 7:
              _this13.pricePostingDuplicateFromPreviousMonth();
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    pricePostingDuplicateFromPreviousMonth: function pricePostingDuplicateFromPreviousMonth() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this$pricePosting$ca2;
        var applicationDate, data, _this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this14.pricePosting.isDataDuplicating = true;
              applicationDate = moment(_this14.pricePosting.form.applicationDate);
              data = {
                applicationYear: applicationDate.year(),
                applicationMonth: applicationDate.month() + 1
              };
              _this = _this14;
              (_this$pricePosting$ca2 = _this.pricePosting.cancellationTokenDuplicate) === null || _this$pricePosting$ca2 === void 0 || _this$pricePosting$ca2.cancel();
              _this.pricePosting.cancellationTokenDuplicate = axios.CancelToken.source();
              _context8.next = 8;
              return request("/v1/price-posting/duplication", "post", data, true, "api", null, _this.pricePosting.cancellationTokenDuplicate).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.pricePosting.isDataDuplicating = false;
                  _this.pricePosting.lastErrorCreating = e.response.data.value;
                  var errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to create price posting", true);
                  handleErrorData(_this, errorData);
                  _this14.fetchPricePostings();
                }
                throw e;
              });
            case 8:
              _this14.pricePosting.isDataDuplicating = false;
              _this14.fetchPricePostings();
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    fetchPricePostings: function fetchPricePostings() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this$pricePosting$ca3;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this15.pricePosting.isDataLoading = true;
              _this15.pricePosting.results.items = [];
              _this15.pricePosting.results.totalCount = 0;
              _this = _this15;
              (_this$pricePosting$ca3 = _this.pricePosting.cancellationTokenGet) === null || _this$pricePosting$ca3 === void 0 || _this$pricePosting$ca3.cancel();
              _this.pricePosting.cancellationTokenGet = axios.CancelToken.source();
              _context9.next = 8;
              return request("/v1/price-posting/", "get", null, true, "api", null, _this.pricePosting.cancellationTokenGet).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.pricePosting.isDataLoading = false;
                  var errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to get price posting list", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 8:
              response = _context9.sent;
              _this15.pricePosting.results.items = _toConsumableArray(response.data.value);
              _this15.pricePosting.results.totalCount = _this15.pricePosting.results.items.length;
              _this15.pricePosting.isDataLoading = false;
            case 12:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    pricePostingDownload: function pricePostingDownload(item) {
      var _this16 = this;
      var url = item.urlBatchFile;
      var date = moment(item.applicationDate).toDate().formatForDatePickerMonths();
      var filename = "PRICEPOSTING_USAPRO_".concat(date, ".csv");
      fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        var blobURL = URL.createObjectURL(blob);
        var downloadLink = document.createElement("a");
        downloadLink.href = blobURL;
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        URL.revokeObjectURL(blobURL);
      }).catch(function () {
        _this16.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    },
    confirmPricePostingDownloadHalFile: function confirmPricePostingDownloadHalFile(item) {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this17.$refs.confirm.open("WARNING", "The file batch is not TRANSFERRABLE in this exact form.<br><br>" + "<strong>Verifications</strong><br>" + "1: Verify that all products available for USA, specially those recently created on the platform, have a hal number set and linked to its hal platform item number.<br>" + "1.bis: Define Hal number in the product page with its missing data. Then, regenerate the csv HAL File, and start again the verifications with the new file.<br><br>" + "<strong>Modifications</strong><br>" + "1: Create a new .xlsx file, and import data from this .csv.<br>" + "2: Keep only the lines with 'Existing Hal item number' not empty (Action = edit), without these informations Capony can't process the file.<br>" + "3 Keep only the lines with 'Has Change' = YES, to comply with Canopy demands, delete other lines.<br>" + "4: Keep only the columns 'Hal number' and 'All prices columns', remove the last column 'New Jersey Brand Registration'", {
                width: 550,
                color: "red",
                isHtmlMessage: true
              });
            case 2:
              ok = _context10.sent;
              if (ok) _this17.pricePostingDownloadHalFile(item);
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    pricePostingDownloadHalFile: function pricePostingDownloadHalFile(item) {
      var _this18 = this;
      var url = item.urlHalPriceFile;
      var date = moment(item.applicationDate).toDate().formatForDatePickerMonths();
      var filename = "PRICEPOSTING_USAPRO_HAL_PRICES_BATCH_".concat(date, ".csv");
      fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        var blobURL = URL.createObjectURL(blob);
        var downloadLink = document.createElement("a");
        downloadLink.href = blobURL;
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        URL.revokeObjectURL(blobURL);
      }).catch(function () {
        _this18.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    },
    confirmPricePostingRegenerateNyslaFile: function confirmPricePostingRegenerateNyslaFile(item) {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this19.$refs.confirm.open("Regenerate file", "After manual modifications, you must regenerate file to be perfectly synchronized with the C&M database. The original file won't be available to download anymore on the platform. Are you sure ?", {
                color: "red"
              });
            case 2:
              ok = _context11.sent;
              if (ok) _this19.pricePostingRegenerateNyslaFile(item);
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    pricePostingRegenerateNyslaFile: function pricePostingRegenerateNyslaFile(item) {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this$pricePosting$re2;
        var _this;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this20.pricePosting.regeneratingNysla.isPending = true;
              _this = _this20;
              (_this$pricePosting$re2 = _this.pricePosting.regeneratingNysla.cancellationToken) === null || _this$pricePosting$re2 === void 0 || _this$pricePosting$re2.cancel();
              _this.pricePosting.regeneratingNysla.cancellationToken = axios.CancelToken.source();
              _context12.next = 6;
              return request("/v1/price-posting/".concat(item.id, "/files/nysla"), "put", null, true, "api", null, _this.pricePosting.regeneratingNysla.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.pricePosting.regeneratingNysla.isPending = false;
                  var errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to regenerate Nysla file", true);
                  handleErrorData(_this, errorData);
                  _this20.fetchPricePostings();
                }
                throw e;
              });
            case 6:
              _this20.pricePosting.regeneratingNysla.isPending = false;
              _this20.fetchPricePostings();
            case 8:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    confirmPricePostingRegenerateHalFile: function confirmPricePostingRegenerateHalFile(item) {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _this21.$refs.confirm.open("Regenerate file", "After manual modifications, you must regenerate file to be perfectly synchronized with the C&M database. The original file won't be available to download anymore on the platform. Are you sure ?", {
                color: "red"
              });
            case 2:
              ok = _context13.sent;
              if (ok) _this21.pricePostingRegenerateHalFile(item);
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    pricePostingRegenerateHalFile: function pricePostingRegenerateHalFile(item) {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this$pricePosting$re3;
        var _this;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this22.pricePosting.regeneratingHal.isPending = true;
              _this = _this22;
              (_this$pricePosting$re3 = _this.pricePosting.regeneratingHal.cancellationToken) === null || _this$pricePosting$re3 === void 0 || _this$pricePosting$re3.cancel();
              _this.pricePosting.regeneratingHal.cancellationToken = axios.CancelToken.source();
              _context14.next = 6;
              return request("/v1/price-posting/".concat(item.id, "/files/hal"), "put", null, true, "api", null, _this.pricePosting.regeneratingHal.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.pricePosting.regeneratingHal.isPending = false;
                  var errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to regenerate Hal file", true);
                  handleErrorData(_this, errorData);
                  _this22.fetchPricePostings();
                }
                throw e;
              });
            case 6:
              _this22.pricePosting.regeneratingHal.isPending = false;
              _this22.fetchPricePostings();
            case 8:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    confirmPricePostingPosted: function confirmPricePostingPosted(item) {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this23.$refs.confirm.open("Declaration posted", "These prices will be used after the application date to concerned customers. You won't be able to regenerate NYSLA file, or HAL file after this action. Are you sure ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(confirm) {
                  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                    while (1) switch (_context15.prev = _context15.next) {
                      case 0:
                        if (!confirm) {
                          _context15.next = 3;
                          break;
                        }
                        _context15.next = 3;
                        return _this23.declarePricePostingAsPosted(item);
                      case 3:
                      case "end":
                        return _context15.stop();
                    }
                  }, _callee15);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    declarePricePostingAsPosted: function declarePricePostingAsPosted(item) {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this = _this24;
              item.isPosting = true;
              _context18.next = 4;
              return request("/v1/price-posting/" + item.id + "/posted", "put", {}, true, "api").catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(e) {
                  var _e$response;
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        item.isPosting = false;
                        if (!((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.errorCode) === "POSTED_TOO_LATE")) {
                          _context17.next = 6;
                          break;
                        }
                        _context17.next = 4;
                        return _this.confirmPricePostingPostedLate(item, e.response.data.value.message);
                      case 4:
                        _context17.next = 8;
                        break;
                      case 6:
                        errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to declare as posted this price posting declaration.", true);
                        _this.$toasted.show(errorData.message, {
                          type: errorData.type
                        });
                      case 8:
                        throw e;
                      case 9:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 4:
              item.isPosting = false;
              _this24.fetchPricePostings();
              _this24.$toasted.show("Price posting declaration posted.", {
                type: "success"
              });
            case 7:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    confirmPricePostingPostedLate: function confirmPricePostingPostedLate(item) {
      var _arguments = arguments,
        _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var message;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              message = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : null;
              if (!message) message = "It seems it's too late to declare this price posting declaration as posted.";
              _this25.$refs.confirm.open("Declaration late", "".concat(message, " Are you sure you want these prices to be applied for the application date defined ?"), {
                width: 450,
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(confirm) {
                  return _regeneratorRuntime().wrap(function _callee19$(_context19) {
                    while (1) switch (_context19.prev = _context19.next) {
                      case 0:
                        if (!confirm) {
                          _context19.next = 3;
                          break;
                        }
                        _context19.next = 3;
                        return _this25.declarePricePostingAsPostedByPassingDate(item);
                      case 3:
                      case "end":
                        return _context19.stop();
                    }
                  }, _callee19);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 3:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    declarePricePostingAsPostedByPassingDate: function declarePricePostingAsPostedByPassingDate(item) {
      var _this26 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _this = _this26;
              data = {
                byPassLate: true
              };
              item.isPosting = true;
              _context22.next = 5;
              return request("/v1/price-posting/" + item.id + "/posted", "put", data, true, "api").catch(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                    while (1) switch (_context21.prev = _context21.next) {
                      case 0:
                        item.isPosting = false;
                        errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to declare as posted this price posting declaration.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context21.stop();
                    }
                  }, _callee21);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 5:
              item.isPosting = false;
              _this26.fetchPricePostings();
              _this26.$toasted.show("Price posting declaration posted.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    confirmPricePostingCancelled: function confirmPricePostingCancelled(item) {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _this27.$refs.confirm.open("Cancel declaration", "Are you sure you want to cancel this price posting declaration ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(confirm) {
                  var _this;
                  return _regeneratorRuntime().wrap(function _callee23$(_context23) {
                    while (1) switch (_context23.prev = _context23.next) {
                      case 0:
                        if (!confirm) {
                          _context23.next = 8;
                          break;
                        }
                        _this = _this27;
                        item.isDeleting = true;
                        _context23.next = 5;
                        return request("/v1/price-posting/" + item.id, "delete", null, true, "api").catch(function (e) {
                          item.isDeleting = false;
                          var errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to cancel this price posting declaration.", true);
                          handleErrorData(_this, errorData);
                          throw e;
                        });
                      case 5:
                        item.isDeleting = false;
                        _this27.fetchPricePostings();
                        _this27.$toasted.show("Price posting declaration cancelled.", {
                          type: "success"
                        });
                      case 8:
                      case "end":
                        return _context23.stop();
                    }
                  }, _callee23);
                }));
                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }))();
    },
    pricePostingDownloadModifications: function pricePostingDownloadModifications(item) {
      var _this28 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var _this$pricePosting$do;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _this28.pricePosting.downloadingModification.isPending = true;
              _this28.pricePosting.downloadingModification.results = [];
              _this = _this28;
              (_this$pricePosting$do = _this.pricePosting.downloadingModification.cancellationToken) === null || _this$pricePosting$do === void 0 || _this$pricePosting$do.cancel();
              _this.pricePosting.downloadingModification.cancellationToken = axios.CancelToken.source();
              _context25.next = 7;
              return request("/v1/price-posting/".concat(item.id, "/modifications"), "get", null, true, "api", null, _this.pricePosting.downloadingModification.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.pricePosting.pricePosting.downloadingModification.isPending = false;
                  var errorData = getErrorData(e, _this.pricePosting.managedExceptions, "Unable to get price posting list", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              response = _context25.sent;
              _this28.pricePosting.downloadingModification.results = _toConsumableArray(response.data.value);
              _this28.pricePostingCreateAndDownloadModificationFile();
              _this28.pricePosting.downloadingModification.isPending = false;
            case 11:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    pricePostingCreateAndDownloadModificationFile: function pricePostingCreateAndDownloadModificationFile() {
      var formattedDate = moment().format("YYYY-MM-DD");
      var fileName = "PRICE_POSTING_MANUAL_MODIFICATIONS-".concat(formattedDate, ".xlsx");
      var data = this.pricePosting.downloadingModification.results.map(function (item) {
        var _item$conditionalDisc;
        return {
          Sku: item.wine.sku,
          Wine: item.wine.displayName,
          Threshold: (_item$conditionalDisc = item.conditionalDiscountThreshold) !== null && _item$conditionalDisc !== void 0 ? _item$conditionalDisc : "-",
          Type: item.modificationType,
          FromUsdShipIncluded: item.modificationType === "EDITION" && item.previousPriceUsdDefaultShippingIncluded ? "".concat(item.previousPriceUsdDefaultShippingIncluded, " $") : "-",
          ToUsdShipIncluded: item.modificationType === "DELETION" ? "-" : "".concat(item.newPriceUsdDefaultShippingIncluded, " $"),
          By: item.lastModifierFullName,
          On: moment(item.lastModificationDate).format("YYYY-MM-DD")
        };
      });
      var worksheet = xlsx.utils.json_to_sheet(data);
      var workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Errors");
      var excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      var dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      fileDownload(dataBlob, fileName, "application/xlsx");
    },
    wineryDashboardsSearch: function wineryDashboardsSearch() {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var _this$wineryDashboard, _this29$wineryDashboa, _this, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!_this29.canManageWineryDashboards) {
                _context26.next = 15;
                break;
              }
              _this29.wineryDashboards.isDataLoading = true;
              _this29.wineryDashboards.results.items = [];
              _this29.wineryDashboards.results.totalCount = 0;
              _this29.wineryDashboards.lastSearch = _objectSpread({}, _this29.wineryDashboards.formSearch);
              _this = _this29;
              (_this$wineryDashboard = _this.wineryDashboards.cancellationToken) === null || _this$wineryDashboard === void 0 || _this$wineryDashboard.cancel();
              _this.wineryDashboards.cancellationToken = axios.CancelToken.source();
              paramsQuery = Object.encodeToUri(_this29.wineryDashboards.formSearch);
              _context26.next = 11;
              return request("/v1/winery-dashboards?params=".concat(paramsQuery), "get", null, true, "api", null, _this.wineryDashboards.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.wineryDashboards.isDataLoading = false;
                  _this.$toasted.show("An error occured. Please contact an administrator.", {
                    type: "error"
                  });
                }
                throw e;
              });
            case 11:
              response = _context26.sent;
              _this29.wineryDashboards.results.items = _toConsumableArray(response.data.value);
              _this29.wineryDashboards.results.totalCount = +((_this29$wineryDashboa = _this29.wineryDashboards.results.items) === null || _this29$wineryDashboa === void 0 ? void 0 : _this29$wineryDashboa.length);
              _this29.wineryDashboards.isDataLoading = false;
            case 15:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }))();
    },
    openAddWineryDashboard: function openAddWineryDashboard() {
      var _this30 = this;
      this.wineryDashboards.editedId = null;
      this.$nextTick(function () {
        _this30.$refs.wineryDashboardForm.open();
      });
    },
    wineryDashboardsRowClick: function wineryDashboardsRowClick(item) {
      var _this31 = this;
      this.wineryDashboards.editedId = item.id;
      this.$nextTick(function () {
        _this31.$refs.wineryDashboardForm.open();
      });
    },
    wineryDashboardCopyLink: function wineryDashboardCopyLink(item) {
      var _this32 = this;
      this.wineryDashboards.isCopyingToClipboard = true;
      setTimeout(function () {
        _this32.wineryDashboards.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(item.absoluteAccessUri);
    },
    openPaymentSearchDialog: function openPaymentSearchDialog() {
      var _this33 = this;
      this.showPaymentSearchDialog = true;
      this.$nextTick(function () {
        _this33.$refs.paymentSearchDialog.open();
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    //We delete all charts on leave to free some memory
    reporting.disposeCharts();
    next();
  }
};